import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import FormRow from "../../common/form/FormRow";
import React, {useMemo} from "react";
import {Control} from "react-hook-form";
import {Paper} from "@mui/material";
import {useTableWithAdjustableOrder} from "../../common/components/table/useTableWithAdjustableOrder";
import {BasicUser} from "../../app/types";
import {formatUserInDropdown} from "../../common/util/formatters";
import {getAutocompleteUsers} from "../../common/util/helpers";
import {useSelector} from "react-redux";
import {selectedSiteSelector} from "../../authentication/redux";

type Props = {
    index: number
    control: Control<any>
}


export const BlfUsersForm = ({ index, control}: Props) => {
    const { t } = useTranslation()

    const site = useSelector(selectedSiteSelector)

    const userOptionParams = useMemo(() => {
        return getAutocompleteUsers(
            t('flows.edit.no-users-found'),
            [],
            false,
            site
        )
    }, [site, t])

    const { table: BusyLampUserTable, selector: BusyLampSelector } = useTableWithAdjustableOrder<BasicUser>(`fieldUpdates.${index}.values.0.stringValues`, userOptionParams, control, formatUserInDropdown, user => user.uuid, t('users.edit.user-select-button'))

    return (<>
        <FormRow>
            <FormFieldBox  mdSize={6}>
                {BusyLampSelector}
            </FormFieldBox>
        </FormRow>
        <FormRow>
            <FormFieldBox mdSize={12}>
                <Paper elevation={2}>
                    <BusyLampUserTable />
                </Paper>
            </FormFieldBox>
        </FormRow>
        </>)
}